<template>
  <div class="user-info">
    <van-cell-group>
      <van-cell title="车牌号码"
                class="cell-custom"
                is-link
                :value="carNo"
                @click="changeCarCard" />
      <!-- <van-cell title="SOC"
                class="cell-custom"
                is-link
                :value="userObject.soc || '--'"/> -->
      <van-cell title="一号多充申请"
                class="cell-custom"
                is-link
                @click="cardMultiple"
                :value="multiCharge[userObject.multiCharge] ? multiCharge[userObject.multiCharge] : '未开通'" />
      
      <van-cell title="发票管理"
                class="cell-custom "
                is-link
                @click="invoiceClick" />
      <van-cell title="充电卡"
                class="cell-custom "
                :class="{'cell-color': cardItem}"
                is-link
                :value="cardItem ? '取消关联': '--'"
                @click="changeCard" />
    </van-cell-group>
    <div class="card-list"
         v-if="cardItem">
      <div class="card-list-item">
        <div class="card-status">关联卡</div>
        <div class="card-number">{{cardItem.cardPkId}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  getUserBaseInfo,
  getCardList,
  unbindCard,
  getCarList
} from "../../common/api";
import {
  Cell,
  CellGroup,
} from "vant";

export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  data() {
    return {
      multiCharge: {
        0: '未开通',
        1: '已开通',
        2: '申请中',
        3: '已拒绝，再次申请',
      },
      
      cardItem: null,
      userObject: {},
      carList: [],
      carNo : ''
    };
  },
  mounted() {
    this.getUserBaseData();
    this.getCardList();
    this.getCarList();
  },

  methods: {
    getCarList(){
      getCarList(null)
        .then(response => {
          if ( response.status == this.$config.ajaxStatus) {
            this.carList = response.data;
            this.carList.map(item=>{
              if(item.hasDefault){
                this.carNo = item.carNo;
              }
            })
            if(this.carNo == '' && this.carList.length > 0){
              this.carNo = this.carList[0].carNo
            }
          }

        })
    },
    cardMultiple() {
      if(!this.userObject.multiCharge || this.userObject.multiCharge == 0 || this.userObject.multiCharge == 3){
        this.$router.push("/userinfo/card-multiple");
      }
    },
    getCardList() {
      getCardList({}).then((ret) => {
        if (ret.status == this.$config.ajaxStatus) {
          if (ret.data) {
            let cardItem = null;
            for (let i in ret.data) {
              if (ret.data[i].status == 0) {
                cardItem = ret.data[i];
              }
            }
            this.cardItem = cardItem;
          }
        }
      });
    },
   
    getUserBaseData() {
      let that = this;
      getUserBaseInfo(null, true)
        .then((response) => {
          if (
            response.status == this.$config.ajaxStatus &&
            response.data.length > 0
          ) {
            let userObject = response.data[0];
            that.userObject = userObject;
            
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeCarCard() {
      if(this.carList.length > 0){
        this.$router.push({
          name: "car-list",
        });
      }else{
        this.$router.push({
          name: "my-license-plate-add",
        });
      }
      
    },
    invoiceClick(){
      this.$router.push({
        name: "my-invoice",
        query:{
          type: '2'
        }
      });
    },
    changeCard() {
      if (this.cardItem) {
        this.$dialog
          .confirm({
            message: "取消之后，充电卡将无法使用",
            confirmButtonText: "取消",
            confirmButtonColor: "#999999",
            cancelButtonColor: "#14CC80",
            cancelButtonText: "注销",
            closeOnPopstate: true,
          })
          .then(() => {})
          .catch(() => {
            unbindCard({ cardPkId: this.cardItem.cardPkId }).then((ret) => {
              if (ret.status == this.$config.ajaxStatus) {
                this.getCardList();
                this.$toast("取消成功");
              }
            });
          });
      }
      
    }
  },
};
</script>

<style scoped lang="less">
.icon {
  width: 0.88rem;
  height: 0.88rem;
  border-radius: 50%;
  background-image: url("../../assets/img/add-user.png");
  background-size: 0.88rem 0.88rem;
  float: right;
  cursor: pointer;
  /*opacity: 0;*/
}
.user-info {
  .van-cell-group .van-cell.img-file {
    padding-top: 0.12rem;
    padding-bottom: 0.12rem;
  }
  .van-cell-group .van-cell {
    color: #333333;
  }
  .van-cell-group .van-cell .van-cell__value {
    color: #999;
  }
  .van-cell-group .cell-color .van-cell__value {
    color: #14cc80;
  }
}

.cell-custom {
  line-height: 0.3rem;
  align-items: center;
}

.card-list {
  padding: 0.2rem;
  .card-list-item {
    border-radius: 0.12rem;
    height: 3.3rem;
    margin-top: 0.2rem;
    color: #fff;
    background-image: url("../../assets/image/card.png");
    background-size: 100% 100%;
    position: relative;
    .card-status {
      padding: 0.3rem 0.2rem;
      font-size: 0.3rem;
      line-height: 0.4rem;
      text-align: right;
    }
    .card-number {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 0.3rem;
      font-size: 0.36rem;
      line-height: 0.5rem;
    }
  }
  .card-list-item:first-child {
    margin-top: 0;
  }
  .card-list-item.op4 {
    opacity: 0.4;
  }
}

</style>

